import api from 'services/api'
import {
  OFFERS_API_SUCCESS,
  OFFERS_API_FAIL,
} from 'src/services/app-state/personalizedRecommendation/constants'

export const recommendationsAPISuccess = data => ({ type: OFFERS_API_SUCCESS, data })
export const recommendationsAPIFail = error => ({ type: OFFERS_API_FAIL, error })

const laodRecommendations = params => (dispatch, store) => {
  const {
    profile: {
      profileId,
    },
  } = store()
  return api
    .request('getOffers', params, {}, { 'WM_CONSUMER.USER_ID': profileId })
}
export default laodRecommendations



// WEBPACK FOOTER //
// ./services/app-state/personalizedRecommendation/actions/personalisation.js